import { Form, Col, Spinner, Button, Dropdown } from 'react-bootstrap';
import { Link as L } from 'react-router-dom';
import { StandardControlProps, useControlState, wrapFormControl, labelHelper } from '../Base';

export function Link(props: StandardControlProps & { type: 'link' }) {
  const { value, outputProps } = useControlState(props);
  const v = value !== undefined ? value.toString():'';
  return wrapFormControl(props, outputProps, undefined, undefined, <label>{v.startsWith('http')? <a href={v}>{props.title}</a>:<L to={v}>{props.title}</L>}</label>);
}